<template>
  <v-layout>
    <template v-for="filter in items">
      <v-switch
        :key="filter.id"
        hide-details
        :label="filter.title"
        :disabled="disabled"
        class="ma-0 pa-2"
        :value="filter.id"
        :value-comparator="
          val => (selectedFilter ? selectedFilter.id === val : false)
        "
        @change="switchFilter($event, filter)"
      />
    </template>
  </v-layout>
</template>

<script>
export default {
  props: ["store", "disabled"],
  computed: {
    items() {
      return this.$store.getters[`${this.store}/filters`];
    },
    selectedFilter() {
      return this.$store.getters[`${this.store}/quickFilter`];
    },
  },
  methods: {
    async switchFilter(switchState, filter) {
      if (switchState) {
        if (
          switchState == this.selectedFilter?.id &&
          switchState == filter?.id
        ) {
          await this.$store.dispatch(`${this.store}/clearQuickFilter`);
          localStorage.setItem("quickFilter", "");
          localStorage.setItem("filter", "");
        } else {
          await this.$store.dispatch(
            `${this.store}/applyQuickFilter`,
            filter.id,
          );
          const parsedSwitchFilter = JSON.stringify(filter);
          localStorage.setItem("quickFilter", parsedSwitchFilter);
          const filterValues = this.$store.getters[`${this.store}/filter`];
          const parsedFilter = JSON.stringify(filterValues);
          localStorage.setItem("filter", parsedFilter);
        }
      } else {
        await this.$store.dispatch(`${this.store}/clearQuickFilter`);
        localStorage.setItem("quickFilter", "");
        localStorage.setItem("filter", "");
      }
    },
  },
};
</script>

<style>
.layout .v-input--selection-controls.v-input .v-label {
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: normal;
  line-height: 1.1;
  padding-top: 5px;
}
.layout .v-input--selection-controls__input {
  align-self: flex-start;
}
</style>
